'use client';
import { CustomProductsCarousel } from '../../components/homepage/custom-products-carousel';
import { useRelatedProducts } from '@eliadmin/core/src/hooks/products/use-related-products';
import { RelatedProductsStatus } from '@eliadmin/core/src/components/product/detail/related-products-status';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
export function ProductRelatedProducts({ slug }: { slug: string }) {
  const { t } = useTranslations();
  const related = useRelatedProducts(slug);
  const products = related.products;
  if (!products.length && !related.isLoading && !related.isError) return null;
  return (
    <>
      {' '}
      {products.length > 0 && (
        <CustomProductsCarousel
          products={products}
          title={t('text60')}
          className={{ section: 'py-12 sm:py-16 md:py-20 lg:py-32 xl:py-40' }}
        />
      )}{' '}
      <div className="mx-auto w-full max-w-screen-2xl px-4">
        <RelatedProductsStatus
          loading={related.isLoading}
          error={related.isError}
          retry={() => {
            void related.refetch();
          }}
        />
      </div>{' '}
    </>
  );
}
